// extracted by mini-css-extract-plugin
module.exports = {"root":"Notification_root__EKpem","notification":"Notification_notification__UAnq9","hint":"Notification_hint__M0Zcv"};